import React, {useState, useEffect} from 'react'
import {withRouter} from 'react-router-dom';
import {Col, Container, Row} from 'react-bootstrap'
import {Card, Empty, Spin, Modal, Tag, Button} from 'antd';
import Api from "../../../services/Api";
import HelperGeneral from "../../../helpers/HelperGeneral";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar, faXmark} from "@fortawesome/free-solid-svg-icons";

const {Meta} = Card;

const Archive = () => {
    const playerRef = React.useRef();
    const [loading, setLoading] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [documentTypes, setDocumentTypes] = useState([]);
    const [loadingDocumentTypes, setLoadingDocumentTypes] = useState(false);
    const [activeDocumentTypeId, setActiveDocumentTypeId] = useState(1);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalMediaUrl, setModalMediaUrl] = useState("");
    const [modalImageVisible, setModalImageVisible] = useState(false);
    const [modalImageUrls, setModalImageUrls] = useState([]);
    const [activeSubCategory, setActiveSubCategory] = useState(0);
    const [overlayColors, setOverlayColors] = useState(
        {
            "AD CARE": "#a4c8e1",
            "DAILY": "#e2d0d8",
            "HYDRA": "#a5d7ef",
            "REPAIR": "#B7BADB",
            "SD CARE": "#A4C8E1",
            "SEBUM": "#59D1BB",
            "SENSETIVE": "#F3D8CB",
            "UV DEFENCE": "#FFCD00",
        }
    );

    useEffect(() => {
        getCategoryList();
        getDocuments();
    }, [])

    useEffect(() => {
        setDocuments([]);
        setActiveSubCategory(0);
        getDocuments();
    }, [activeDocumentTypeId])

    const getDocuments = (subCategory) => {
        setLoading(true);
        if (activeDocumentTypeId !== 0) {
            let args = ['other_1'];
            if (subCategory) {
                args.push(subCategory);
            }
            Api.getDocuments(...args).then((e) => {
                setLoading(false);
                setDocuments(e?.data?.data ?? []);
            }).catch((e) => {
                HelperGeneral.alert(e);
                setLoading(false);
            })
        }
    }

    const getCategoryList = () => {
        setLoadingDocumentTypes(true);
        Api.getCategoryList('other_1').then((e) => {
            setDocumentTypes(e?.data);
            setActiveDocumentTypeId(e?.data[0]?.id);
            setLoadingDocumentTypes(false);
        }).catch((e) => {
            setLoadingDocumentTypes(false);
            HelperGeneral.alert(e);
        })
    }

    const cardImgTemplate = (v) => {
        return (
            <div className={"position-relative"}>
                {
                    v?.isNew && (
                        <Tag
                            className={"bg-danger text-white rounded border-0 position-absolute"}
                            style={{right: 0, top: 10}}
                        >
                            <FontAwesomeIcon icon={faStar}/> YENİ
                        </Tag>
                    )
                }
                <img
                    alt={v?.name}
                    className={"mt-2 mb-2 w-100"}
                    src={require("../../../assets/images/png/theme/SHINIQ_Logo.png")}
                    onError={(e) => {
                        e.target.src = require("../../../assets/images/png/theme/SHINIQ_Logo.png")
                    }}
                />
            </div>
        )
    }

    const modalCancel = () => {
        setModalVisible(false);
        const el = playerRef.current;

        if (!el) return;

        if (typeof el.pause === "function") {
            el.pause();
            el.currentTime = 0;
            return;
        }

        if (el.video && typeof el.video.pause === "function") {
            el.video.pause();
            el.video.currentTime = 0;
        }
    };

    return (
        <div className={'my-account product-category archive pt-4 pb-4 min-height-container'}>
            <Container>
                <Row>
                    {
                        documents?.data?.filter((e) => e?.category_name === "Sensitive - Hassas Ciltler").map((data) => (
                            <Col xs={12}>
                                <span>{data?.url}</span>
                            </Col>
                        ))
                    }
                    <Col xs={12} md={3}>
                        <Row>
                            <Col xs={12} className={'position-relative'}>
                                <Spin spinning={loadingDocumentTypes}>
                                    <div className={'category-left-menu rounded pt-4 pb-4'}>
                                        <div className={`showFull`}>
                                            <h5 className={"text-center"}>Dokümanlar</h5>
                                            <ul>
                                                {
                                                    documentTypes?.map((v, i) => (
                                                            <li
                                                                key={i}
                                                                onClick={() => {
                                                                    setActiveDocumentTypeId(v?.id)
                                                                }}
                                                                style={{
                                                                    '--overlay-color': '#FDE5D9',
                                                                    background: (activeDocumentTypeId === v?.id ? '#FDE5D9' : ''),
                                                                }}>
                                                                <span className={`main-category `}>{v?.name}</span>
                                                            </li>
                                                        )
                                                    )
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </Spin>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={9}>
                        {
                            documentTypes?.filter((data) => data?.id === activeDocumentTypeId)[0]?.subCats?.length > 0 && (
                                <Container>
                                    <Row>
                                        <div className={'documents-filter-div'}>
                                            {
                                                documentTypes?.filter((data) => data?.id === activeDocumentTypeId)[0]?.subCats?.map((v) => (
                                                    <button
                                                        onClick={() => {
                                                            if (v?.id === activeSubCategory) {
                                                                getDocuments();
                                                                setActiveSubCategory(0);
                                                            } else {
                                                                getDocuments(v?.id);
                                                                setActiveSubCategory(v?.id);
                                                            }
                                                        }}
                                                        className={activeSubCategory === v?.id ? 'active' : ''}
                                                        style={activeSubCategory === v?.id ? {backgroundColor: overlayColors[v?.name], borderColor: overlayColors[v?.name]} : {}}
                                                        key={v?.id}
                                                    >
                                                        <span>{v?.name}</span>
                                                    </button>
                                                ))
                                            }
                                            {
                                                activeSubCategory !== 0 && (
                                                    <button
                                                        onClick={() => {
                                                            getDocuments();
                                                            setActiveSubCategory(0);
                                                        }}
                                                        className={'clear'}
                                                    >
                                                        <span>Temizle <FontAwesomeIcon icon={faXmark} size={8}/></span>
                                                    </button>
                                                )
                                            }
                                        </div>
                                    </Row>
                                </Container>
                            )
                        }
                        <Spin spinning={loading}>
                            <Row>
                                {
                                    documents?.filter((data) => data?.category?.parentId === activeDocumentTypeId).map((v, i) => (
                                        <Col xs={12} md={6} xl={4} className={'mb-4'}>
                                            {
                                                v?.info?.filesUrls?.length > 0 ? (
                                                    <Card
                                                        style={{cursor: 'pointer'}}
                                                        className={'archive-card'}
                                                        onClick={() => v?.info?.filesUrls?.length > 0 ? window.open(v?.info?.filesUrls[0]?.url, "_blank") : false}
                                                        cover={cardImgTemplate(v)}
                                                    >
                                                        <Meta title={v?.info?.name}/>
                                                    </Card>
                                                ) : (
                                                    v?.info?.videosUrls?.length > 0 ? (
                                                        <Card
                                                            style={{cursor: "pointer"}}
                                                            className="archive-card"
                                                            cover={cardImgTemplate(v)}
                                                            onClick={() => {
                                                                const url = v?.info?.videosUrls?.[0]?.url;
                                                                if (!url) return;

                                                                setModalMediaUrl(url);
                                                                setModalVisible(true);
                                                            }}
                                                        >
                                                            <Meta title={v?.info?.name}/>
                                                        </Card>
                                                    ) : (
                                                        v?.info?.galleryImagesUrls && v?.info?.galleryImagesUrls.length > 0 ? (
                                                            <Card
                                                                style={{cursor: 'pointer'}}
                                                                className="archive-card"
                                                                cover={cardImgTemplate(v)}
                                                                onClick={() => {
                                                                    const urls = v?.info?.galleryImagesUrls?.map((img) => img?.raw).filter(Boolean) ?? [];
                                                                    if (urls.length > 0) {
                                                                        setModalImageUrls(urls);
                                                                        setModalImageVisible(true);
                                                                    }
                                                                }}
                                                            >
                                                                <Meta title={v?.info?.name}/>
                                                            </Card>
                                                        ) : (
                                                            <Card
                                                                style={{cursor: 'pointer'}}
                                                                className="archive-card"
                                                                cover={cardImgTemplate(v)}
                                                            >
                                                                <Meta title={v?.info?.name}/>
                                                            </Card>
                                                        )
                                                    )
                                                )
                                            }
                                        </Col>
                                    ))
                                }
                                {
                                    !loading && documents?.filter((data) => data?.category?.parentId === activeDocumentTypeId)?.length < 1 && activeDocumentTypeId !== 7 && (
                                        <Empty description={'Arşiv kaydı bulunamadı'}/>
                                    )
                                }
                                <Modal
                                    visible={modalVisible}
                                    centered
                                    footer={null}
                                    onCancel={modalCancel}
                                    width={1000}
                                    destroyOnClose
                                >
                                    <video
                                        ref={playerRef}
                                        src={modalMediaUrl}
                                        controls
                                        autoPlay
                                        style={{width: "100%", height: "600px"}}
                                    />
                                </Modal>
                                <Modal
                                    visible={modalImageVisible}
                                    centered
                                    footer={null}
                                    onCancel={() => setModalImageVisible(false)}
                                    width="90%"
                                    style={{maxWidth: 900}}
                                    destroyOnClose
                                >
                                    {modalImageUrls?.length > 0 && (
                                        <div className="text-center">
                                            <img
                                                src={modalImageUrls[0]}
                                                alt=""
                                                style={{maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain'}}
                                            />
                                            <div className="mt-3">
                                                <Button
                                                    type="primary"
                                                    onClick={() => {
                                                        const url = modalImageUrls[0];
                                                        if (!url) return;
                                                        fetch(url, { mode: 'cors' })
                                                            .then((res) => res.blob())
                                                            .then((blob) => {
                                                                const blobUrl = window.URL.createObjectURL(blob);
                                                                const a = document.createElement('a');
                                                                a.href = blobUrl;
                                                                a.download = 'gorsel.' + (blob.type.split('/')[1] || 'png');
                                                                a.rel = 'noopener noreferrer';
                                                                a.click();
                                                                window.URL.revokeObjectURL(blobUrl);
                                                            })
                                                            .catch(() => window.open(url, '_blank'));
                                                    }}
                                                >
                                                    İndir
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </Modal>
                            </Row>
                        </Spin>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default withRouter(Archive);
